import React, { useState } from 'react';
import { PAYS, composerNumero, decouperNumero } from '../../utils/phone';

interface PhoneInputProps {
  /** Numéro E.164 (`+224620000099`) */
  value: string | undefined;
  onChange: (valeur: string) => void;
  onBlur?: () => void;
  id?: string;
  className?: string;
  placeholder?: string;
}

/**
 * Saisie d'un téléphone : indicatif pays (+224 par défaut) + numéro national.
 * Émet toujours le numéro composé en E.164, prêt à être enregistré.
 */
const PhoneInput: React.FC<PhoneInputProps> = ({ value, onChange, onBlur, id, className = '', placeholder = '620 00 00 00' }) => {
  const initial = decouperNumero(value);
  // L'indicatif est gardé localement : tant que le numéro est vide, la valeur
  // émise est vide et ne pourrait pas le porter.
  const [indicatif, setIndicatif] = useState(initial.indicatif);
  const national = value ? decouperNumero(value).national : '';

  return (
    <div className="flex gap-2">
      <select
        aria-label="Indicatif pays"
        value={indicatif}
        onChange={e => { setIndicatif(e.target.value); onChange(composerNumero(e.target.value, national)); }}
        className={`${className} !w-28 shrink-0 text-gray-700`}
      >
        {PAYS.map(p => (
          <option key={p.iso} value={p.indicatif}>{`+${p.indicatif} ${p.nom}`}</option>
        ))}
      </select>
      <input
        id={id}
        type="tel"
        inputMode="numeric"
        value={national}
        onChange={e => onChange(composerNumero(indicatif, e.target.value))}
        onBlur={onBlur}
        placeholder={placeholder}
        className={`${className} min-w-0 flex-1 text-gray-700`}
      />
    </div>
  );
};

export default PhoneInput;
